/**
 * @flow
 * @relayHash 0a63db0b59405e5b4c6dac4204d7804e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FishLeaderboardResultSubscriptionVariables = {|
  event_token: string
|};
export type FishLeaderboardResultSubscriptionResponse = {|
  +updateFishLeaderboard: ?{|
    +event_token: string
  |}
|};
export type FishLeaderboardResultSubscription = {|
  variables: FishLeaderboardResultSubscriptionVariables,
  response: FishLeaderboardResultSubscriptionResponse,
|};
*/


/*
subscription FishLeaderboardResultSubscription(
  $event_token: String!
) {
  updateFishLeaderboard(event_token: $event_token) {
    event_token
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_token",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFishLeaderboard",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event_token",
        "variableName": "event_token"
      }
    ],
    "concreteType": "updateFishLeaderboardType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "event_token",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FishLeaderboardResultSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FishLeaderboardResultSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "FishLeaderboardResultSubscription",
    "id": null,
    "text": "subscription FishLeaderboardResultSubscription(\n  $event_token: String!\n) {\n  updateFishLeaderboard(event_token: $event_token) {\n    event_token\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '582125a0bee5e4a69931378c85c40bca';
module.exports = node;
